// contant.js
import i18n from "@/plugins/i18n";

export const regions = [
  { value: 0, label: i18n.t("wap.text1") },
  { value: 1, label: i18n.t("wap.text2") },
  { value: 3, label: i18n.t("wap.text3") },
  { value: 2, label: i18n.t("wap.text4") }
];

export const sessions = [
  { value: 1, label: i18n.t("wap.text5") },
  { value: 2, label: i18n.t("wap.text6") },
  { value: 3, label: i18n.t("wap.text7") }
];

export const STATUS_PAYMENT = [
  { value: 1, label: i18n.t("wap.text8") },
  { value: 2, label: i18n.t("wap.text9") },
  { value: 3, label: i18n.t("wap.text10") }
  // { value: 4, label: "Đã hủy" }
];
export const STATUS_BILL = {
  0: i18n.t("wap.text8"),
  1: i18n.t("wap.text10"),
  2: i18n.t("wap.text11"),
  3: i18n.t("wap.text9"),
  "-1": i18n.t("wap.text8")
};

export const LIST_POLICY = [
  {
    label: i18n.t("cancellationPolicy"),
    key: "cancellation",
    link: "/policy/cancellation"
  },
  {
    label: i18n.t("payPolicy"),
    key: "payment",
    link: "/policy/payment"
  },
  {
    label: i18n.t("deliveryPolicy"),
    key: "delivery",
    link: "/policy/delivery"
  },
  {
    label: i18n.t("cusInfoSecurityPolicy"),
    key: "cusInfoSecurityPolicy",
    link: "/policy/user-info-security"
  },
  {
    label: i18n.t("paymentInfoSecurityPolicy"),
    key: "paymentInfoSecurityPolicy",
    link: "/policy/payment-info-security"
  },
  {
    label: i18n.t("complaints"),
    key: "complaints",
    link: "/policy/complaint-resolution-mechanism"
  },
  {
    label: i18n.t("termsTransaction"),
    key: "termsTransaction",
    link: "/policy/terms-transaction"
  }
];

export const LIST_PROD_BANK = [
  {
    label: i18n.t("wap.text111"),
    key: "service-nab",
    link:
      "https://www.namabank.com.vn/Data/Sites/1/media/the/2023/Golf/DKDK%20CHI%20TIET%20CHUONG%20TRINH%20UU%20DAI%20DAC%20QUYEN%20THE%20TIN%20D%E1%BB%A4NG%20HAPPY%20GOLF%2012.07.2023.pdf"
  },
  {
    label: i18n.t("wap.text112"),
    key: "service-stb",
    link:
      "https://www.sacombank.com.vn/content/dam/sacombank/files/ca-nhan/the/tin-dung/Sacombank_DKDKSuDungUuDaiGolf.pdf"
  },
  {
    label: i18n.t("wap.text113"),
    key: "service-tech",
    link:
      "https://techcombank.com/content/dam/techcombank/public-site/documents/the-le-chi-tiet-golf-private-26072024.pdf"
  }
];
// export const SOURCE_BANK = {
//   VIETIN: 5, // Vietin Bank 5
//   NAB: 4, // NAB Bank 4
//   SCB: 6, // SCB Bank 6,
//   BIDV: 7,
//   JinPro: 9 //JinPro
// };
const VIETIN = 1,
  NAB = 2,
  SCB = 3,
  BIDV = 7,
  VG = 8,
  JinPro = 9,
  VNEWS = 10,
  FB = 11,
  ZALO = 12,
  EVGA = 13;
export const SOURCE_BANK = {
  NAB: 4,
  VIETIN: 5,
  BIDV,
  VG,
  JinPro,
  VNEWS,
  FB,
  ZALO,
  EVGA, VNA: 14
};
export const CB_DELIVERY_CODE = 'CB0';
export const REVERSED_SOURCE_BANK = Object.fromEntries(
  Object.entries(SOURCE_BANK).map(([key, value]) => [value, key])
);
export const list_screen = [
  {
    key: 6,
    mapBankId: null,
    title: "Home Booking Wap/Web"
  },
  {
    key: 11,
    mapBankId: SOURCE_BANK.NAB,
    title: "Home Hio Wap/Web Nam Á Bank"
  },
  {
    key: 12,
    mapBankId: SOURCE_BANK.SCB,
    title: "Home Hio Wap/Web Sacombank"
  },
  {
    key: 13,
    mapBankId: SOURCE_BANK.VIETIN,
    title: "Home Hio Wap/Web Vietinbank"
  },
  {
    key: 14,
    mapBankId: SOURCE_BANK.BIDV,
    title: "Home Hio Wap/Web BIDV"
  }
];
export const list_path_by_source = [
  {
    source_id: SOURCE_BANK.JinPro,
    path: "/jinpro",
    name: REVERSED_SOURCE_BANK[SOURCE_BANK.JinPro]
  },
  {
    source_id: SOURCE_BANK.EVGA,
    path: "/evga",
    name: REVERSED_SOURCE_BANK[SOURCE_BANK.EVGA]
  }
];
